export default {"src":"/_next/static/media/Base.f06e6681.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};